/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectRequestBody
 */
export interface RejectRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RejectRequestBody
     */
    note: string;
}

/**
 * Check if a given object implements the RejectRequestBody interface.
 */
export function instanceOfRejectRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "note" in value;

    return isInstance;
}

export function RejectRequestBodyFromJSON(json: any): RejectRequestBody {
    return RejectRequestBodyFromJSONTyped(json, false);
}

export function RejectRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function RejectRequestBodyToJSON(value?: RejectRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}

